export default __webpack_public_path__ + "static/media/collections_5.731ec7a1.webp";